"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * StateStore stores state and allows an observer to subscribe to state updates
 */
var StateStore = function () {
  function StateStore() {
    _classCallCheck(this, StateStore);

    this._listeners = [];
    this._state = {};
  }

  _createClass(StateStore, [{
    key: "update",
    value: function update(props) {
      // Always create a new state object.
      // if lastState === newState then state hasn't changed
      this._state = Object.assign({}, this._state, props);
      this._listeners.forEach(function (listener) {
        return listener(props);
      });
    }
  }, {
    key: "subscribeUpdates",
    value: function subscribeUpdates(listener) {
      this._listeners.push(listener);
    }
  }, {
    key: "unsubscribeUpdates",
    value: function unsubscribeUpdates(listener) {
      this._listeners = this._listeners.filter(function (l) {
        return l !== listener;
      });
    }
  }, {
    key: "state",
    get: function get() {
      return this._state;
    }
  }]);

  return StateStore;
}();

exports.default = StateStore;